var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.07 121.785L408.285 256 274.07 390.215l-28.285-28.285 85.93-85.93H104v-40h227.715l-85.93-85.93zM512 256c0 68.379-26.629 132.668-74.98 181.02C388.668 485.37 324.379 512 256 512s-132.668-26.629-181.02-74.98C26.63 388.668 0 324.379 0 256S26.629 123.332 74.98 74.98C123.332 26.63 187.621 0 256 0s132.668 26.629 181.02 74.98C485.37 123.332 512 187.621 512 256zm-40 0c0-119.102-96.898-216-216-216S40 136.898 40 256s96.898 216 216 216 216-96.898 216-216zm0 0"
  })));
}

export default SvgArrowCircle;